import React, { useState, useEffect } from "react"
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import { Steps } from "rsuite"
import Swal from "sweetalert2"
import { useNavigate, useParams } from "react-router-dom"
import SelectMultiple from "../../components/SelectMultiple"
import RenderInput from "../../components/RenderInput"
import "rsuite/Steps/styles/index.css";
import { getOrDeleteRequest, postOrPutRequest, getSession } from "../../utils/utils"
import MainThemeLayout from "../../layout/MainThemeLayout"
import { es } from 'date-fns/locale/es';

import "react-datepicker/dist/react-datepicker.css";

registerLocale('es', es);

const AddReport = ({ withLayout, withLogo, report = false }) => {
  const navigate = useNavigate()
  const { id, date } = useParams()

  const [ribbons, setRibbons] = useState([])
  const [fileName, setFileName] = useState(null)
  const [currentStep, setCurrentStep] = useState(id ? 1 : 0)
  const [reportedMonth, setReportedMonth] = useState([])
  const [projectId, setProjectId] = useState(null)
  const [form, setForm] = useState({
    id: null,
    name: "",
    description: "",
    reported_month: "",
    questions: [],
    partners: [],
    sections: [],
  })
  const [results, setResults] = useState({
    questions: [
      {
        id: null,
        response: null, // Text, number, array
        question_id: null,
      },
    ],
  })
  const [projects, setProjects] = useState([])
  // const [formErrors, setFormErrors] = useState({});
  const [buttonDisable, setButtonDisable] = useState(true);

  function convertirFecha(fecha) {
    const [mes, anio] = fecha.split("-")
    return `${anio}-${mes.padStart(2, "0")}-01`
  }

  const getRibbons = async (project) => {
    const response = await getOrDeleteRequest(`ribbon/filter`, "GET", null, false)
    if (response.type === "success") {
      if (response.data.length > 0) {
        setRibbons(response.data)
      }
    }
  }

  const getRibbonImage = (ribbonId) => {
    if (!ribbons || ribbons.length === 0) {
      return null
    }
    const ribbon = ribbons.find((item) => item.project_id === ribbonId)
    if (ribbon) {
      return `${process.env.REACT_APP_PHOTO_URI}photo/ribbon/image/${ribbon.image}`
    }
    return null
  }

  const getData = async (id_data) => {
    // let response = await getOrDeleteRequest(
    //   `forms/show/${id}`,
    //   'GET',
    //   null,
    //   true
    // );

    // if (response.type === 'success') {
    //   let sections = [];

    //   response.data.form_pages.forEach((page) => {
    //     console.log(page, 'page');
    //     let itemPage = page.order_page > 0 ? page.order_page - 1 : 0;

    //     let simpleQuestions = page.question_pages.map((question) => {
    //       let info = question.questions;
    //       return {
    //         id: info.id,
    //         question: info.question,
    //         required: info.is_required === 1 ? true : false,
    //         order_question: info.order_question,
    //         type: info.question_type?.input,
    //         options: info.options,
    //         placeholder: info.placeholder ?? null,
    //         description: info.description ?? null,
    //         is_question: true,
    //         // response: null,
    //       };
    //     }).sort((a, b) => a.order_question - b.order_question);

    //     let groupedQuestions = page.question_groups.map((group, index) => {
    //       let questionGroup = [];
    //       // console.log(group.group_details, 'group.group_details');
    //       // Adjuntamos el enunciado del grupo al inicio de las preguntas
    //       let groupInfo = {
    //         id: group.id,
    //         question: group.title,
    //         required: false,
    //         order_question: 0,
    //         type: 'group',
    //         options: null,
    //         placeholder: null,
    //         description: null,
    //         is_question: false,
    //         // response: null,
    //       };

    //       questionGroup.push(groupInfo);

    //       group.group_details.forEach((question) => {
    //         let info = question.questions;
    //         let detailsQuestion = {
    //           id: info.id,
    //           question: info.question,
    //           required: info.is_required === 1 ? true : false,
    //           order_question: info.order_question,
    //           type: info.question_type?.input,
    //           options: info.options,
    //           placeholder: info.placeholder ?? null,
    //           description: info.description ?? null,
    //           is_question: true,
    //           // response: null,
    //         };

    //         questionGroup.push(detailsQuestion);
    //       });

    //       return questionGroup.sort((a, b) => a.order_question - b.order_question);
    //     }).sort((a, b) => a.order_question - b.order_question);
    //     // console.log(groupedQuestions, 'groupedQuestions');
    //     let questions = [];

    //     if (simpleQuestions.length > 0) {
    //       questions = simpleQuestions;
    //     }

    //     if (groupedQuestions.length > 0) {
    //       // Removemos los elementos que ya están en groupedQuestions de simpleQuestions
    //       questions = questions.filter((simple) => {
    //         let found = groupedQuestions.find((group) => {
    //           return group.some((question) => question.id === simple.id);
    //         });

    //         return !found;
    //       });

    //       groupedQuestions.forEach((group) => {
    //         questions = [...questions, ...group];
    //       });
    //     }

    //     // console.log(questions, 'questions');
    //     sections[itemPage] = questions;
    //   });

    //   let newForm = {
    //     id: response.data.id,
    //     name: response.data.name,
    //     pages: response.data.quantity_pages,
    //     description: response.data.description,
    //     //     questions: formQuestions,
    //     //     partners: response.data.partners,
    //     sections: sections,
    //     reported_month: form.reported_month || '',
    //   };
    //   // console.log(newForm, 'newForm');
    //   setForm(newForm);
    // }

    const response = await postOrPutRequest(
      id ? `forms/list-report/${id_data}` : `forms/project-company/${id_data}`,
      "POST",
      {
        company_id: getSession().company.id,
        ...(id && {
          reported_month: convertirFecha(date),
          project_id: id,
        }),
      },
      true,
    )

    // console.log(id ? `forms/list-report/${id_data}` : `forms/project-company/${id_data}`, 'url');

    // console.log(response, 'responseeeeeeeeeeeee');

    if (response.type === "success") {
      const sections = []

      response.data.form_pages.forEach((page) => {
        // console.log(page, 'page');
        const itemPage = page.order_page > 0 ? page.order_page - 1 : 0

        const simpleQuestions = page.question_pages
          .map((question) => {
            const info = question.questions
            // console.log(info, 'info');
            return {
              id: id ? info?.response[0]?.id : info.id,
              response_id: id ? info?.response[0]?.id : info.id,
              question: info.question,
              question_id: info.id,
              required: info.is_required,
              order_question: info.order_question,
              type: info.question_type?.input,
              options: info.options,
              placeholder: info.placeholder ?? null,
              description: info.description ?? null,
              is_question: true,
              value: info.value,
              min_characters: info?.min_characters,
              max_characters: info?.max_characters,
              min_value: info?.min_value,
              max_value: info?.max_value,
              decimal_places: info?.decimal_places,
              allow_zero: info?.allow_zero,
              // response: null,
            }
          })
          .sort((a, b) => a.order_question - b.order_question)

        const groupedQuestions = page.question_groups
          .map((group, index) => {
            const questionGroup = []
            // console.log(group.group_details, 'group.group_details');
            // Adjuntamos el enunciado del grupo al inicio de las preguntas
            const groupInfo = {
              id: group.id,
              question: group.title,
              required: false,
              order_question: 0,
              type: "group",
              options: null,
              placeholder: null,
              description: null,
              is_question: false,
              // response: null,
            }

            questionGroup.push(groupInfo)

            group.group_details.forEach((question) => {
              const info = question.questions
              const detailsQuestion = {
                id: id ? info?.response[0]?.id : info.id,
                response_id: id ? info?.response[0]?.id : info.id,
                question_id: info.id,
                question: info.question,
                required: info.is_required,
                order_question: info.order_question,
                type: info.question_type?.input,
                options: info.options,
                placeholder: info.placeholder ?? null,
                description: info.description ?? null,
                is_question: true,
                value: info.value || null,
                min_characters: info?.min_characters,
                max_characters: info?.max_characters,
                min_value: info?.min_value,
                max_value: info?.max_value,
                decimal_places: info?.decimal_places,
                allow_zero: info?.allow_zero,
                // response: null,
              }

              questionGroup.push(detailsQuestion)
            })

            return questionGroup.sort((a, b) => a.order_question - b.order_question)
          })
          .sort((a, b) => a.order_question - b.order_question)
        // console.log(groupedQuestions, 'groupedQuestions');
        let questions = []

        if (simpleQuestions.length > 0) {
          questions = simpleQuestions
        }

        if (groupedQuestions.length > 0) {
          // Removemos los elementos que ya están en groupedQuestions de simpleQuestions
          questions = questions.filter((simple) => {
            const found = groupedQuestions.find((group) => {
              return group.some((question) => question.id === simple.id)
            })

            return !found
          })

          groupedQuestions.forEach((group) => {
            questions = [...questions, ...group]
          })
        }

        // console.log(questions, 'questions');
        sections[itemPage] = questions
      })

      const newForm = {
        id: response.data.id,
        name: response.data.name,
        pages: response.data.quantity_pages,
        description: response.data.description,
        //     questions: formQuestions,
        //     partners: response.data.partners,
        sections: sections,
        reported_month: form.reported_month || "",
      }
      // console.log(newForm, 'newForm');
      setForm(newForm)
    }
  }

  const getProjects = async () => {
    const session = getSession()

    // console.log(session, 'session');

    const response = await getOrDeleteRequest(`projects/projectbycompanyActive/${session.company.id}`, "GET")

    // console.log(response, 'response getProjects');

    if (response.type === "success") {
      setProjects(response.data)
      return
    }

    setProjects([])
    return
  }

  const hanldeChange = React.useCallback(
    (e) => {
      const responseId = e.target.dataset.uuid
      const questionId = e.target.dataset.question_id
      // console.log(e.target, 'e.target');
      const { type, value, checked, dataset } = e.target
      const optionId = dataset?.option

      setResults((prevResults) => {
        const normalizedId = String(responseId)
        let newResponse

        switch (type) {
          case "checkbox":
            const currentOptions = prevResults.questions.find((q) => String(q.id) === normalizedId)?.response || []
            newResponse = checked
              ? [...new Set([...currentOptions, optionId])]
              : currentOptions.filter((opt) => opt !== optionId)
            break
          case "radio":
            newResponse = optionId
            break
          default:
            newResponse = value
        }

        // console.log(questionId, 'questionId');

        // Encontrar el índice de la pregunta existente
        const questionIndex = prevResults.questions.findIndex((q) => String(q.id) === normalizedId)

        let updatedQuestions
        if (questionIndex !== -1) {
          // Actualizar la pregunta existente
          updatedQuestions = [...prevResults.questions]
          updatedQuestions[questionIndex] = {
            ...updatedQuestions[questionIndex],
            question_id: questionId,
            response: newResponse,
          }
        } else {
          // Agregar nueva pregunta
          updatedQuestions = [
            ...prevResults.questions,
            {
              id: responseId,
              response: newResponse,
              question_id: questionId,
            },
          ]
        }

        const newResults = { ...prevResults, questions: updatedQuestions }
        // console.log(newResults, 'newResults');
        sessionStorage.setItem(id ? "editReport" : "formReport", JSON.stringify(newResults))
        return newResults
      })
    },
    [id],
  )

  const handleSubmit = async () => {
    setButtonDisable(false);
    // Alerta para simular que ya se cumplió el limite de registros en el mes
    // Swal.fire({
    //     title: '¡Limite de reportes!',
    //     text: 'Ha alcanzado el límite de reportes para este mes',
    //     icon: 'warning',
    //     confirmButtonText: 'Aceptar',
    // });

    // return;
    const data = JSON.parse(sessionStorage.getItem(id ? "editReport" : "formReport"))

    const session = getSession()

    // console.log(session, 'session');

    // console.log(data, 'dataaa');

    const company_id = session.company?.id
    const arrayComplement = {
      company_id: company_id,
      reported_month: id ? convertirFecha(date) : form.reported_month,
    }

    const items = data.questions
      .filter((item) => item.response !== null)
      .flatMap((item) => {
        // console.log(item, 'item');
        const base = {
          response: item.response,
          question_id: item.question_id,
          ...arrayComplement,
        }

        if (id) {
          return {
            ...base,
            response_id: item.id !== undefined || item.id !== "undefined" ? item.id : null,
          }
        } else {
          return {
            ...base,
            questions_id: item.id,
          }
        }
      })

    // console.log(items, 'items');

    const newData = {
      ...(id
        ? {
            responses: items.filter(
              (item) => item.response !== null && item.response !== "" && item.response !== undefined,
            ),
            ...arrayComplement,
          }
        : { questions: items, forms_id: form.id, ...arrayComplement }),
    }

    // console.log(newData, 'newData');

    if (id) {
      if (newData.responses.length === 0) {
        Swal.fire({
          title: "¡Éxito!",
          text: "Cambios guardados correctamente",
          icon: "success",
          confirmButtonText: "Aceptar",
          timer: 3000,
        }).then(() => {
          navigate("/Reportes")
        })
        return
      }
    }

    const response = await postOrPutRequest(
      id ? `forms/update-report/${id}?_method=PUT` : `response/create`,
      "POST",
      newData,
    )

    if (response.type === "success") {
      sessionStorage.removeItem(id ? "editReport" : "formReport")

      Swal.fire({
        title: "¡Datos registrados!",
        text: "Datos registrados correctamente",
        icon: "success",
        confirmButtonText: "Aceptar",
        timer: 3000,
      }).then(() => {
        navigate("/PanelDeControl")
      })
    }
  }

  const handleProjectChange = (e) => {
    const value = e
    getData(value)
  }

  const getLastMonths = async (project = null) => {
    const session = getSession()
    const company = session.company

    let uri = `company/report-months/${company.id}`
    if (project) {
      uri += `?project_id=${project}`
    }

    const response = await getOrDeleteRequest(uri, "GET")
    const reportedMonths = response.data || [] // Asegurar que reportedMonths no sea undefined

    setReportedMonth(reportedMonths)
    return reportedMonths
  }

  const loadData = async () => {
    await getRibbons()

    // if (id) return;

    await getProjects()

    const savedData = JSON.parse(sessionStorage.getItem(id ? "editReport" : "formReport"))
    // console.log(savedData, 'savedData');
    if (savedData) {
      // Normaliza los datos para checkboxes (asegura que sean arrays)
      const normalizedData = {
        ...savedData,
        questions: savedData.questions.map((q) => ({
          ...q,
          id: String(q.id),
          question_id: String(q.question_id),
          response:
            q.type === "checkbox"
              ? Array.isArray(q.response)
                ? q.response
                : [q.response].filter(Boolean)
              : q.response,
        })),
      }

      setResults(normalizedData)
    }
  }

  useEffect(() => {
    loadData()
    if (id) {
      sessionStorage.removeItem(id ? "editReport" : "formReport")
      getData(id)
    }
  }, [])

  // const handleKeyDown = (e) => {
  //       let rawValue = e.target.value;

  //       if (rawValue === '' || /^-?\d*\.?\d*$/.test(rawValue)) {
  //           const numericValue =
  //               rawValue === '' ||
  //               rawValue === '-' ||
  //               rawValue === '.' ||
  //               rawValue === '-.'
  //                   ? null
  //                   : Number(rawValue);
        
        
  //           // Validamos el valor mínimo
  //           if (
  //               numericValue !== null && 
  //               question.min_value !== undefined &&
  //               numericValue < question.min_value
  //           ) {
  //               // setInputValue(question.min_value.toString());
  //               Swal.fire({
  //                   icon: 'warning',
  //                   title: 'Valor mínimo excedido',
  //                   text: `El valor mínimo permitido es ${question.min_value}.`,
  //                   confirmButtonText: 'Aceptar'
  //               });
  //               return;
  //           }
    
  //           // Validamos el valor máximo
  //           if (
  //               numericValue !== null && 
  //               question.max_value !== undefined &&
  //               numericValue > question.max_value
  //           ) {
  //               Swal.fire({
  //                   icon: 'warning',
  //                   title: 'Valor máximo excedido',
  //                   text: `El valor máximo permitido es ${question.max_value}.`,
  //                   confirmButtonText: 'Aceptar'
  //               });
  //               return;
  //           }
    
  //           // Validamos si se permite cero
  //           if (
  //               numericValue === 0 && 
  //               question.allow_zero === false
  //           ) {
  //               Swal.fire({
  //                   icon: 'warning',
  //                   title: 'Cero no permitido',
  //                   text: `El valor cero no está permitido para esta pregunta.`,
  //                   confirmButtonText: 'Aceptar'
  //               });
  //               return;
  //           }
    
  //           // Validamos el espacio decimal
  //           if (question.decimal_places !== undefined && question.decimal_places >= 0) {
  //               const parts = rawValue.split('.');
  //               if (parts.length === 2 && parts[1].length > question.decimal_places) {
  //                   const truncatedDecimal = parts[1].substring(0, question.decimal_places);
  //                   const newValue = `${parts[0]}.${truncatedDecimal}`;
  //                   setInputValue(newValue);
  //                   return;
  //               }
  //           }
  //       }

  //   };

  const validateCurrentStep = () => {
    // Si estamos en el paso 0 (selección de proyecto y mes)
    if (currentStep === 0) {
      if (!id) {
        // Validar que ambos campos estén completos
        if (!projectId || !form.reported_month) {
          Swal.fire({
            title: "Algunos campos requeridos están incompletos o no son válidos.",
            text: "Por favor, complete todos los campos requeridos antes de continuar o verifique que las respuestas sean válidas.",
            icon: "warning",
            confirmButtonText: "Aceptar",
          })
          return false
        }
      }
      return true
    }

    // Para pasos del formulario (step > 0)
    const currentQuestions = form.sections[currentStep - 1] || []

    // console.log('Validando paso:', currentStep);
    // console.log('Preguntas del paso actual:', currentQuestions);
    // console.log('Respuestas en results.questions:', results.questions);

    // Filtramos solo las preguntas que son requeridas
    const requiredQuestions = currentQuestions.filter(
      (question) => question.required === true && question.is_question === true,
    )

    // console.log('Preguntas requeridas:', requiredQuestions);

    const isValid = requiredQuestions.every((question) => {
      // Buscar la respuesta usando string comparison para evitar problemas de tipo
      const foundQuestion = results.questions.find((q) => String(q.id) === String(question.id))

      // console.log(`Validando pregunta ${question.id}:`, foundQuestion);

      // Si no se encontró la pregunta en las respuestas
      if (!foundQuestion) {
        // console.log(`Pregunta no encontrada para validación: ${question.id}`);
        return false
      }

      const response = foundQuestion.response

      // Validar según el tipo de respuesta
      if (response === null || response === undefined) {
        // console.log(`Respuesta nula o indefinida para la pregunta: ${question.id}`);
        return false
      }

      if (typeof response === "string" && response.trim() === "") {
        // console.log(`Respuesta vacía para la pregunta: ${question.id}`);
        return false
      }

      if (Array.isArray(response) && response.length === 0) {
        // console.log(`Array vacío para la pregunta: ${question.id}`);
        return false
      }

      // Si la respuesta es numérica, verificamos las reglas de max, min y allow_zero
      if (question.type === "number") {
        const numericValue = Number(response);

        if (isNaN(numericValue)) {
          // console.log(`Respuesta no numérica para la pregunta: ${question.id}`);
          return false;
        }

        console.log("question ===>", question);

        if (question.min_value !== undefined && numericValue < question.min_value && question.allow_zero === false) {
          console.log(`Valor por debajo del mínimo para la pregunta: `, question);
          return false;
        }

        if(numericValue !== 0 && question.min_value !== undefined && numericValue < question.min_value) {
          console.log(`Valor por debajo del mínimo para la pregunta: `, question);
          return false;
        }

        if (question.max_value !== undefined && numericValue > question.max_value) {
          // console.log(`Valor por encima del máximo para la pregunta: ${question.id}`);
          return false;
        }

        if (question.allow_zero === false && numericValue === 0) {
          // console.log(`Cero no permitido para la pregunta: ${question.id}`);
          return false;
        }
      }

      if (response === false) {
        // console.log(`Respuesta false para la pregunta: ${question.id}`);
        return false
      }

      // console.log(`Pregunta ${question.id} válida:`, response);
      return true
    })

    if (!isValid) {
      Swal.fire({
        title: "Algunos campos requeridos están incompletos o no son válidos.",
        text: "Por favor, complete todos los campos requeridos antes de continuar o verifique que las respuestas sean válidas.",
        icon: "warning",
        confirmButtonText: "Aceptar",
      })
      return false
    }

    // console.log('Paso validado correctamente');
    return true
  }

  const goToNextStep = () => {
    if (validateCurrentStep()) {
      document.getElementById("containerForm").scrollTo({ top: 0, behavior: "smooth" })
      setCurrentStep((prev) => prev + 1)
      sessionStorage.setItem(id ? "editReport" : "formReport", JSON.stringify(results))
    }
  }

  const goToPreviousStep = () => {
    document.getElementById("containerForm").scrollTo({ top: 0, behavior: "smooth" })
    setCurrentStep((prev) => prev - 1)

    // let savedData = JSON.parse(sessionStorage.getItem('formReport'));
    // if (savedData) {
    //   setResults(savedData);
    // }
  }

  useEffect(() => {
    const handleSessionUpdate = () => {
      const savedData = JSON.parse(sessionStorage.getItem(id ? "editReport" : "formReport"))
      if (savedData) {
        const currentIds = new Set(results?.questions?.map((q) => q.id)) // ids ya existentes

        const normalizedData = {
          ...savedData,
          questions: savedData.questions.map((q) => {
            // console.log(q, 'q from session');

            if (currentIds.has(String(q.id))) {
              return q
            }

            return {
              ...q,
              id: String(q.id),
              question_id: String(q.question_id),
              response:
                q.type === "checkbox"
                  ? Array.isArray(q.response)
                    ? q.response
                    : [q.response].filter(Boolean)
                  : q.response,
            }
          }),
        }

        setResults(normalizedData)
      }
    }

    window.addEventListener("session-update", handleSessionUpdate)
    return () => window.removeEventListener("session-update", handleSessionUpdate)
  }, [])

  const content = (
    <div className="flex flex-col h-screen">
      <div className="relative flex flex-col h-full max-w-2xl mx-auto w-full px-3 sm:px-4 md:px-6 bg-white dark:bg-stone-800">
        {/* Encabezado */}
        <div className="flex-shrink-0 pt-3 sm:pt-4">
          {/* {withLogo && (
            <div className="mb-2">
              <span className="bg-transparent dark:bg-white rounded-lg p-1 sm:p-2 md:p-3 inline-block">
                <img src={logoPequeño || "/placeholder.svg"} alt="Logo FUNDEMAS" className="w-28 sm:w-36 md:w-48" />
              </span>
            </div>
          )} */}
          {fileName && (
            <div className="flex justify-center mb-3">
              <img src={fileName || "/placeholder.svg"} className="max-h-32 sm:max-h-40 object-contain" alt="" />
            </div>
          )}
        </div>

        {/* Contenedor principal con espacio reservado para el footer */}
        <div className="flex flex-col flex-1 min-h-0 bg-white dark:bg-stone-800">
          {/* Formulario - área scrollable */}
          <form className="flex-1 overflow-y-auto min-h-0" id="containerForm">
            <div className="pb-36 px-1">
              {!id && currentStep === 0 ? (
                <div className="space-y-4">
                  <h1 className="text-lg font-medium text-stone-700 dark:text-white">
                    Seleccione el proyecto al que desea registrar datos
                  </h1>
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-slate-700 dark:text-white mb-1">Proyecto</label>
                      <SelectMultiple
                        name="project_id"
                        array={projects}
                        value={projectId}
                        onChange={(e) => {
                          handleProjectChange(e)
                          getLastMonths(e)
                          setProjectId(e)
                          setFileName(getRibbonImage(e))
                        }}
                        placeholder="Seleccione un proyecto"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-slate-700 dark:text-white mb-1">
                        Mes a reportar
                      </label>
                      <DatePicker 
                        className="w-full px-3 py-2 border border-gray-300 dark:border-stone-600 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-turquesa focus:border-turquesa dark:bg-stone-700 dark:text-white text-base"
                        locale="es"
                        name="reported_month"
                        dateFormat={"MMMM, yyyy"}
                        // selected={startDate} 
                        maxDate={new Date()}
                        value={form.reported_month}
                        showMonthYearPicker
                        onChange={(date) => {
                          let selectedMonth = "";

                          if (date instanceof Date && !isNaN(date)) {
                            const month = (date.getMonth() + 1).toString().padStart(2, "0");
                            const year = date.getFullYear();
                            selectedMonth = `${year}-${month}`; // Formato: YYYY-MM
                          }

                          // Validar si el mes ya fue reportado
                          if (reportedMonth.includes(selectedMonth)) {
                            Swal.fire({
                              title: "Mes ya reportado",
                              text: "Este mes ya ha sido reportado para el proyecto seleccionado.",
                              icon: "warning",
                              confirmButtonText: "Aceptar",
                            });
                            return;
                          }

                          setForm({ ...form, reported_month: selectedMonth });
                        }} 
                      />
                      {/* <input
                        type="month"
                        name="reported_month"
                        value={form.reported_month}
                        onChange={(e) => {
                          const selectedMonth = e.target.value // Formato: YYYY-MM

                          // Validar si el mes ya fue reportado
                          if (reportedMonth.includes(selectedMonth)) {
                            Swal.fire({
                              title: "Mes ya reportado",
                              text: "Este mes ya ha sido reportado para el proyecto seleccionado.",
                              icon: "warning",
                              confirmButtonText: "Aceptar",
                            })
                            return
                          }

                          setForm({ ...form, reported_month: selectedMonth })
                        }}
                        className="w-full px-3 py-2 border border-gray-300 dark:border-stone-600 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-turquesa focus:border-turquesa dark:bg-stone-700 dark:text-white text-base"
                        placeholder="Seleccione mes y año"
                        max={new Date().toISOString().slice(0, 7)} // Limita a mes actual
                      /> */}
                      <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                        Seleccione el mes y año que desea reportar
                      </p>
                    </div>
                  </div>
                </div>
              ) : (
                currentStep > 0 && (
                  <div className="space-y-4">
                    <h1 className="text-lg font-medium text-stone-700 dark:text-white">{form?.name ?? ""}</h1>
                    {form.sections.length > 0 &&
                      form.sections[currentStep - 1].map((question, index) => (
                        <RenderInput
                          key={index}
                          question={question}
                          sectionIndex={currentStep}
                          index={index}
                          form={results}
                          hanldeChange={hanldeChange}
                        />
                      ))}
                  </div>
                )
              )}
            </div>
          </form>

          {/* Footer fijo */}
          <div
            className={`sticky bottom-0 pt-3 pb-6 px-4 ${form.sections.length > 0 ? "bg-white dark:bg-stone-800 border-t border-gray-200 dark:border-stone-700" : ""}`}
          >
            <Steps current={currentStep} className="mb-3 overflow-x-auto">
              {form.sections.length > 0 && <Steps.Item icon={<></>} />}
              {form.sections.map((_, index) => (
                <Steps.Item key={index} icon={<></>} />
              ))}
            </Steps>

            <div className="flex justify-between gap-2 flex-wrap">
              {currentStep === 0 && report && (
                <button
                  type="button"
                  className="bg-gray-500 text-white py-2 px-3 rounded-md text-sm flex-1"
                  onClick={() => navigate("/PanelDeControl")}
                >
                  Completar más tarde
                </button>
              )}

              {((!id && currentStep > 0) || (id && currentStep > 1)) && (
                <button
                  type="button"
                  className="bg-gray-500 text-white py-2 px-3 rounded-md text-sm flex-1"
                  onClick={goToPreviousStep}
                >
                  Anterior
                </button>
              )}

              {currentStep < form.sections.length ? (
                <button
                  type="button"
                  className="bg-turquesa text-white py-2 px-3 rounded-md text-sm flex-1"
                  onClick={() => {
                    goToNextStep()
                  }}
                >
                  Siguiente
                </button>
              ) : (
                (currentStep !== 0) && (
                  <button
                    type="button"
                    className={"bg-turquesa text-white py-2 px-3 rounded-md text-sm flex-1" + (buttonDisable ? "" : " opacity-50 cursor-not-allowed")}
                    disabled={!buttonDisable}
                    onClick={() => {
                      if (validateCurrentStep()) {
                        handleSubmit()
                      }
                    }}
                  >
                    {id ? "Actualizar Reporte" : "Registrar Reporte"}
                  </button>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )

  return withLayout ? <MainThemeLayout>{content}</MainThemeLayout> : content
}

export default AddReport
